import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, Transition as _Transition, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-28ba3785"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-window" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-content" }, null, -1))
const _hoisted_3 = { class: "container" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "詳細情報", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "企画ID", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "商品区分名", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "企画担当者", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "重量", -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "タイトル", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "タイトル（カナ）", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "製本仕様", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, "判型", -1))

import axios from 'axios';
import { onMounted, ref } from 'vue';
import { useStore } from 'vuex';

interface KikakuDetail {
  kikakuId?: number;
  syohinKbnId?: number;
  userName?: string;
  weight: number;
  kikakuMei: string,
  kikakuMeiKana: string,
  kariSiyo:{
      seihonSiyo: string,
      hangata: string,
      weight:number
  }

}



export default /*#__PURE__*/_defineComponent({
  __name: 'ModalRyuyoDetails',
  props: {
    selectId: Number
},
  setup(__props) {

const store = useStore();
const props = __props

const kikakuData = ref<KikakuDetail>();
onMounted (() => {
    axios.get(`${store.getters["getBaseUrl"]}/kikaku/detail?kikakuId=${props.selectId}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
      },
    }).then((response) => {
        kikakuData.value = response.data;
    })
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "modal",
    appear: ""
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: "modal modal-overlay",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('closeModal')), ["self"]))
      }, [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", null, [
              _createElementVNode("div", null, [
                _hoisted_4,
                _createElementVNode("table", null, [
                  _createElementVNode("thead", null, [
                    _createElementVNode("tr", null, [
                      _hoisted_5,
                      _createElementVNode("td", null, _toDisplayString(kikakuData.value?.kikakuId), 1),
                      _hoisted_6,
                      _createElementVNode("td", null, _toDisplayString(kikakuData.value?.syohinKbnId), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_7,
                      _createElementVNode("td", null, _toDisplayString(kikakuData.value?.userName), 1),
                      _hoisted_8,
                      _createElementVNode("td", null, _toDisplayString(kikakuData.value?.kariSiyo.weight), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_9,
                      _createElementVNode("td", null, _toDisplayString(kikakuData.value?.kikakuMei), 1),
                      _hoisted_10,
                      _createElementVNode("td", null, _toDisplayString(kikakuData.value?.kikakuMeiKana), 1)
                    ]),
                    _createElementVNode("tr", null, [
                      _hoisted_11,
                      _createElementVNode("td", null, _toDisplayString(kikakuData.value?.kariSiyo.seihonSiyo), 1),
                      _hoisted_12,
                      _createElementVNode("td", null, _toDisplayString(kikakuData.value?.kariSiyo.hangata), 1)
                    ])
                  ])
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }))
}
}

})